import * as React from 'react';
import { CombinedFilterViewProps } from '../components/filters/filter';

const MultiSelectFilterView: React.StatelessComponent<CombinedFilterViewProps> = props => {
    function onChange(evt: React.ChangeEvent<HTMLInputElement>) {
        // Grab the selected option's data-first-occurance attribute.
        const selectedValue = evt.currentTarget.value;
        console.log(selectedValue);
        const currentSelections = props.selectedValue ? props.selectedValue.split(',') : [];
        console.log(currentSelections);
        const toUpdate = currentSelections.indexOf(selectedValue) !== -1 ? currentSelections.filter(a => a !== selectedValue) : currentSelections.concat(selectedValue);
        console.log(toUpdate.join());
        props.selectFilter(toUpdate.join());
    }

    return (
        <li className="filters-list-item">
            <fieldset>
                <legend>{props.filterName}</legend>
                <ul className="filter-list">
                    {
                        props.options.map(option => {
                            return (
                                <li key={`${option.value}~${option.text}`}>
                                    <input type="checkbox" id={`${props.filterName}~${option.value}~${option.text}`} value={`${option.value}|${option.text}`} checked={props.selectedValue ? props.selectedValue.split(',').indexOf(`${option.value}|${option.text}`) !== -1 : false} onChange={onChange} data-first-occurance={option.firstOccurance}/>
                                    <label htmlFor={`${props.filterName}~${option.value}~${option.text}`}>{option.text}</label>
                                </li>
                            )
                        })
                    }
                </ul>
            </fieldset>
        </li>
    );
}

export default MultiSelectFilterView;